<template>
    <div class="page-body">
      <div class="container-fluid">
        <div class="edit-profile">
          <div class="row">
            <div class="col-12 col-xl-12">
              <div class="card">
                <div class="card-header">
                  <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                    {{ categoryId && categoryId !== '' ? "Editar Categoría" : "Crear Categoría" }}
                  </div>
                </div>
                <div class="card-body" style="margin-top: 20px;">
                  <form @submit.prevent="submitForm">
                    <div class="flex flex-col md:flex-row gap-4 md:gap-8">
                      <!-- ID y Nombre -->
                      <div class="flex flex-col gap-4 w-full md:w-[300px]">
                        <div class="w-full h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Nombre</label>
                          <input 
                            type="text" 
                            v-model="form.name_category"
                            class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                            placeholder="Nombre de la categoría" 
                            
                          />
                          <!-- Alerta para nombre -->
                          <div v-if="showNameAlert" class="required-alert">
                            <div class="yellow-box">!</div>
                            <span>Completa este campo</span>
                          </div>
                        </div>
                      </div>
                      <!-- Descripción -->
                      <div class="w-full md:w-[716px] h-[168px] flex-col justify-start items-start gap-1.5 inline-flex">
                        <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Descripción</label>
                        <textarea 
                          v-model="form.description"
                          class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                          placeholder="Descripción de la categoría" 
                          
                        ></textarea>
                         <!-- Alerta para descripción -->
                         <div v-if="showDescriptionAlert" class="required-alert">
                          <div class="yellow-box">!</div>
                          <span>Añade una descripción</span>
                        </div>
                      </div>
                    </div>
                    <!-- Botón -->
                    <div class="form-footer flex sm:flex-row mt-4">
                      <button type="button" class="custom-cancel-btn w-full sm:w-auto" @click="cancelChanges">
                        <span class="custom-cancel-btn-text">Cancelar</span>
                      </button>
                      <button type="submit" class="custom-create-btn w-full sm:w-auto" :disabled="isSubmitting"
                      :class="{ 'disabled-button': isSubmitting }">
                        <span class="custom-create-btn-text">{{ isSubmitting ? 'Guardando...' : 'Guardar' }}</span>
                      </button>
                    </div>
                  </form>
                </div>
                <!-- Mensaje de éxito -->
                <div v-if="successMessage" class="user-alert">
                  <div class="user-alert-content">
                    <div class="user-alert-text">
                      {{ successMessage }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { ref, computed, onMounted } from "vue";
  import { useStore } from "vuex";
  import { useRouter } from "vue-router";
  import { useRoute } from "vue-router";
  
  export default {
    setup() {
      const store = useStore();
      const session = computed(() => store.getters.getUserSession);
      const route = useRoute();
      const categoryId = computed(() => route.params.id);  // Obtener el ID del rol desde la URL
      const isSubmitting = ref(false); // Bloqueo de boton guardar
      const form = ref({
        id: "",
        name_category: "",
        description: ""
      });
      const successMessage = ref("");
      const showNameAlert = ref(false);
      const showDescriptionAlert = ref(false);
      const router = useRouter();

      // Función para validar el nombre
      const validateName = () => {
        if (form.value.name_category.trim() !== '') {
          showNameAlert.value = false;
        }
      };
      
      // Función para validar la descripción
      const validateDescription = () => {
        if (form.value.description.trim() !== '') {
          showDescriptionAlert.value = false;
        }
      };
  
      // Función para cargar los datos del rol cuando estamos en modo de edición
      const loadCategoryData = async () => {
        if (categoryId.value) {
          try {
            const token = session.value.token_api;
            if (!token) {
              console.error("No se ha encontrado el token de autenticación.");
              return;
            }
  
            const options = {
              headers: {
                Authorization: `Bearer ${token}`
              }
            };
  
            // Hacer la solicitud GET para obtener los datos del rol
            const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/categoria-form/${categoryId.value}`, options);
            console.log(response)
            if (response.status === 200) {
              // Asignar los datos al formulario
              form.value.id = response.data.data.id;
              form.value.name_category = response.data.data.name;
              form.value.description = response.data.data.description;
            }
          } catch (error) {
            console.error("Error al cargar los datos del rol:", error);
          }
        }
      };
  
      // Llamar a la función cuando el componente se monta
      onMounted(() => {
        console.log("cargcategoryIdoId:", categoryId.value); // Muestra el valor de categoryId
        loadCategoryData();
      });
  
      // Limpiar todas las alertas
      const submitForm = async () => {
        
        // Validar campos antes de enviar
        let isValid = true;
        
        if (form.value.name_category.trim() === '') {
          showNameAlert.value = true;
          isValid = false;
        } else {
          showNameAlert.value = false;
        }
        
        if (form.value.description.trim() === '') {
          showDescriptionAlert.value = true;
          isValid = false;
        } else {
          showDescriptionAlert.value = false;
        }
        
        if (!isValid) { 
          return; // Detiene el envío si hay campos inválidos
        }

        if (isSubmitting.value) return; // Evita múltiples envíos
        isSubmitting.value = true;

        try {
          const token = session.value.token_api;
          if (!token) {
            console.error("No se ha encontrado el token de autenticación.");
            isSubmitting.value = false;
            return;
          }

          const options = {
            headers: {
              Authorization: `Bearer ${token}`
            }
          };

          const endpoint = categoryId.value
            ? `${process.env.VUE_APP_API_BASE_URL}/categoria-form/${categoryId.value}`
            : `${process.env.VUE_APP_API_BASE_URL}/categoria-form`;
          
          // Change this to use PUT for updating an existing category
          const method = categoryId.value ? "post" : "post";
          
          const dataToSend = { 
            ...form.value,
            category_id: categoryId.value // Add this to help your backend identify the category to update
          };

          // Hacer la solicitud para guardar o actualizar la categoría
          const response = await axios[method](endpoint, dataToSend, options);

          if (response.status === 200 || response.status === 201) {
            successMessage.value = "Categoría guardado con éxito.";

            // Limpiar el formulario si es una nueva categoría
            if (!categoryId.value) {
              form.value.name_category = "";
              form.value.description = "";
            }

            setTimeout(() => {
              successMessage.value = "";
              router.push({ name: "categorias_list" });
            }, 2000);
          }
        } catch (error) {
          console.error("Error al guardar el cargo:", error);
          if (error.response) {
            console.error("Error de servidor:", error.response.data);
          }
        } finally {
          isSubmitting.value = false; 
          }
      };
      // Función computada para verificar si todos los campos están llenos
      const allFieldsFilled = computed(() => {
        return (
          form.value.name_category.trim() !== '' &&
          form.value.description.trim() !== ''
        );
      });

      const cancelChanges = () => {
        router.push({ name: "categorias_list" });
      };
  
      return {
        categoryId,
        form,
        submitForm,
        successMessage,
        showNameAlert,
        showDescriptionAlert,
        validateName,
        validateDescription,
        isSubmitting,
        cancelChanges,
        allFieldsFilled
      };
    }
  };
  </script>
  
  <style scoped>
  .required-alert {
  display: flex; /* Permite alinear elementos en línea (texto y cuadro) */
  align-items: center; /* Centra el contenido verticalmente */
  background-color: #fff; /* Fondo blanco */
  color: #333; /* Texto en gris oscuro */
  padding: 10px;
  border: 1px solid #ccc; /* Borde gris */
  border-radius: 5px; /* Esquinas redondeadas */
  margin-top: 5px;
  position: relative; /* Para el triángulo */
  max-width: 300px; /* Ajusta el tamaño máximo si lo necesitas */
  word-wrap: break-word; /* Evita que el texto se desborde */
}

.required-alert .yellow-box {
  display: flex; /* Para centrar el contenido del cuadro */
  justify-content: center; /* Centra el contenido horizontalmente */
  align-items: center; /* Centra el contenido verticalmente */
  width: 24px; /* Tamaño del cuadro amarillo */
  height: 24px;
  background-color: #e59035; /* Color amarillo */
  margin-right: 10px; /* Espaciado entre el cuadro y el texto */
  border: 1px solid #e59035; /* Borde amarillo más oscuro */
  border-radius: 4px; /* Esquinas redondeadas */
  color: #fff; /* Color blanco para el texto */
  font-weight: bold; /* Hace el signo más visible */
  font-size: 16px; /* Ajusta el tamaño del signo */
  line-height: 1; /* Asegura que no haya espacio adicional */
}

.required-alert::after {
  content: "";
  position: absolute;
  top: -10px; /* Coloca el pico hacia arriba */
  left: 20px; /* Coloca el pico a la izquierda, ajustado desde el borde */
  width: 0;
  height: 0;
  border-left: 10px solid transparent; /* Lado izquierdo del borde */
  border-right: 10px solid transparent; /* Lado derecho del borde */
  border-bottom: 10px solid #fff; /* El triángulo blanco */
  z-index: 1; /* Asegura que quede sobre el fondo */
}

.required-alert::before {
  content: "";
  position: absolute;
  top: -11px; /* Coloca el borde gris un poco más arriba */
  left: 19px; /* Ajusta para alinearlo con el triángulo blanco */
  width: 0;
  height: 0;
  border-left: 11px solid transparent; /* Lado izquierdo del borde gris */
  border-right: 11px solid transparent; /* Lado derecho del borde gris */
  border-bottom: 11px solid #ccc; /* El borde gris */
  z-index: 0; /* Asegura que quede detrás del triángulo blanco */
}

.custom-cancel-btn {
  display: inline-flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #4B5563; /* Gris oscuro */
  border: 1px solid #4B5563;
  color: white;
  cursor: pointer;
  margin-right: 10px; /* Espacio entre botones */
  transition: all 0.3s ease;
}

.custom-cancel-btn-text {
  color: #FFF;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.custom-create-btn {
  display: inline-flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #ff4265;
  border: 1px solid #ff4265;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.custom-create-btn-text {
  color: #FFF;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  width: 100%;
}

.disabled-button {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Estilos responsivos */
@media (max-width: 767px) {
  .card-body {
    padding: 15px;
  }
  
  .flex-col-mobile {
    flex-direction: column;
  }
  
  .w-full-mobile {
    width: 100% !important;
  }
  
  .space-x-4 {
    margin-left: 0;
    margin-right: 0;
  }
  
  .gap-8 {
    gap: 1rem;
  }
  
  .form-footer {
    flex-direction: column;
    gap: 10px;
  }
  
  .custom-cancel-btn, 
  .custom-create-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
}

@media (min-width: 768px) {
  .form-footer {
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>